module.exports = __webpack_public_path__ + "static/media/biuro2.38d08691.jpg";